module.exports = __webpack_public_path__ + "com_index_1bg.jpg?815c09471c54ec25aea1e9e0e58e1cf8";


//////////////////
// WEBPACK FOOTER
// ./static/images/com_index_1bg.jpg
// module id = 121
// module chunks = 0